var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgListBullets = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 5.36606H16.6705",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6711 9.99887H9.16797",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.832 14.6356H16.6678",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.74887 4.94922C3.51866 4.94922 3.33203 5.13584 3.33203 5.36606C3.33203 5.59627 3.51866 5.7829 3.74887 5.7829C3.97909 5.7829 4.16571 5.59627 4.16571 5.36606C4.16571 5.13584 3.97909 4.94922 3.74887 4.94922",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.41684 9.58203C5.18663 9.58203 5 9.76866 5 9.99887C5 10.2291 5.18663 10.4157 5.41684 10.4157C5.64705 10.4157 5.83368 10.2291 5.83368 9.99887C5.83368 9.76866 5.64705 9.58203 5.41684 9.58203",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.0809 14.2188C6.85069 14.2188 6.66406 14.4054 6.66406 14.6356C6.66406 14.8658 6.85069 15.0524 7.0809 15.0524C7.31112 15.0524 7.49774 14.8658 7.49774 14.6356C7.49774 14.4054 7.31112 14.2188 7.0809 14.2188",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgListBullets, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/list-bullets.4743cafd.svg";
export { ForwardRef as ReactComponent };